// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { fetchProductTrainingList, editProductTrainingListStatus, deleteProductTraining } from "../../../Redux/Slices/contentManagementSlice";

// styles
import "./styles.scss";

//assets
import assets from "../../../Assets";

//utils
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import Button from "Components/Button";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import Modal from "Components/Common/Modal";
import InputBox from "Components/InputBox";

const ProductTrainingProgram = () => {
  const headerDetails = [
    {
      label: "Product Category",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "product_category_name" });
      },
    },
    {
      label: "Learning Type",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "learning_type" });
      },
    },
    {
      label: "Learning Title",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "learning_title" });
      },
    },
    {
      label: "File Type",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "file_type" });
      },
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "visible_status" });
      },
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPage = 10;
  const [productTrainingList, setProductTrainingList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalPage, setTotalPage] = useState(1);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productToDelete, setproductToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sortOptions, setSortOptions] = useState({
    sort_by: false,
    order_by: "createdAt",
  });
  // to trigger rerender after status change
  const [productStatus, setProductStatus] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  //to be used for API Calls

  const changeStatus = (status,id) => {
    console.log(status,id)
    if(status === 1){
      status = 2
    }
    else{
      status = 1
    }
    dispatch(
      editProductTrainingListStatus({
        data:{
          status:status,
          id:id
        },
        callBack: ProductTrainingStatusChangeCB,
      })
    )
  }

  const ProductTrainingStatusChangeCB = (value) => {
    //triggers rerender after status change
    setProductStatus(!productStatus);
    //closes the options menu
    setOpenMenuId(null);
  };

  const deleteProduct = ()=>{
    if (productToDelete) {
    dispatch(
      deleteProductTraining({
      data:{
        id:productToDelete
      },
      callBack: deleteProductCB,
    }))}
    setIsModalOpen(false);
  }

  const deleteProductCB = (value) => {
    console.log(value);
    notifySuccess("Product Training Deleted Successfully");
    //triggers rerender after status change
    setProductStatus(!productStatus);
    //closes the options menu
    setOpenMenuId(null);
  };

  useEffect(() => {
    setCurrentPage(1)
  }, [search])

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchProductTrainingList({
        data: {
          search: search,
          page: currentPage,
          limit: rowsPerPage,
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
        },
        callBack: productTrainingListCB,
      })
    );
  }, [sortOptions, currentPage, productStatus]);

  const productTrainingListCB = (value) => {
    setProductTrainingList(value.data.data_list);
    setTotalPage(value.data.pageMeta.totalPages);
    setIsLoading(false);
  };

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);

    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  const openDeleteConfirmationModal = (productId) => {
    setproductToDelete(productId);
    setIsModalOpen(true);
    setOpenMenuId(null)
  };

  return (
    <div className="productTrainingProgramsContainer">
      <div className="productTrainingProgramsHeader">
        <div className="productTrainingProgramsHeading">
          Product Trainings
        </div>
        <div className="productTrainingProgramsSearch">
          <div>
            <InputBox
              value={search}
              icon={assets.Icons.searchIcon}
              onChange={(e) => setSearch(e.target.value)}
              inputStyle={{
                padding: "1px 2vh 1px 7vh",
                border: "none",
                height: "43px",
                width: "25vw",
                borderRadius: "0px",
                borderBottom: "1px solid #C1C7CD",
                boxShadow: "none",
                color: "black",
              }}
            />
          </div>
          <div
            className="productTrainingProgramsButton"
            onClick={() => navigate("/contentManagement/addProductTraining")}
          >
            <Button buttonStyle={{ height: "1vh" }} title="Add New" />
          </div>
        </div>
      </div>
      <div className="productTrainingProgramsTable">
        <NormalTable
          headerDetails={headerDetails}
          // pagination={true}
        >
          {productTrainingList.length > 0
            ? productTrainingList.map((list) => {
                return (
                  <>
                    <tr
                      key={list.createdAt}
                      className="border"
                      style={{ position: "relative" }}
                    >
                      <td style={{paddingLeft:'1vw'}}>{list.product_category_name}</td>
                      <td>
                        {list.learning_type === 1
                          ? "READING AND WRITING"
                          : list.learning_type === 2
                          ? "VISUAL"
                          : list.learning_type === 3
                          ? "AUDITORY"
                          : "KINESTHETIC"}
                      </td>
                      <td>{list.learning_title}</td>
                      <td>{list?.file_type || '-'}</td>
                      <td
                        style={{
                          color: `${
                            list.visible_status === 1 ? "#10CA23" : "#FF482F"
                          }`,
                        }}
                      >
                        {list.visible_status === 1 ? "Visible" : "Hidden"}
                      </td>
                      <td  style={{ zIndex: 10 }}>
                        <img
                          style={{ height: "15px", cursor: "pointer" }}
                          src={assets.Icons.optionsIcon}
                          alt="Options"
                          onClick={() => toggleMenu(list.product_training_id)} // Open menu for this row
                        />
                        {openMenuId === list.product_training_id && (
                          <div className="optionsMenu">
                            <ul>
                              <li onClick={() => navigate(`/contentManagement/viewProductTraining/${list.product_training_id}`)}>
                                <img src={assets.Icons.viewIcon} alt="" />
                                View
                              </li>
                              <li onClick={() => navigate(`/contentManagement/editProductTraining/${list.product_training_id}`)}>
                                <img src={assets.Icons.editIcon} alt="" />
                                Edit
                              </li>
                              <li onClick={() => openDeleteConfirmationModal(list.product_training_id)}>
                                <img src={assets.Icons.deleteIcon} alt="" />
                                Delete
                              </li>
                              <li onClick={() => changeStatus(list.visible_status,list.product_training_id)}>
                                <img
                                  src={assets.Icons.activeInactiveIcon}
                                  alt=""
                                />
                                Mark as{" "}
                                {list.visible_status === 2 ? "Visible" : "Hidden"}
                              </li>
                            </ul>
                          </div>
                        )}
                      </td>
                    </tr>
                  </>
                );
              })
              : isLoading ? "Loading..." : "No Data"}
        </NormalTable>
        <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
              <h3 style={{ textAlign:'center', fontFamily:'Roboto' }}>Are you sure you want to delete this Training?</h3>
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-around', paddingTop:'20px' }}>
              <Button
              buttonStyle={{
                width: "40%",
                height: "2vh",
              }}
               title='Delete'
               onClick={deleteProduct}
              />
              <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                    width: "40%",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={() => setIsModalOpen(false)}
                />
            </div>
          </Modal>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default ProductTrainingProgram;
